export type Feature =
  | 'contacts'
  | 'circles'
  | 'labels'
  | 'interactions'
  | 'todos'
  | 'gifts'
  | 'voice_notes'
  | 'reminders'
  | 'search'
  | 'import'
  | 'export'
  // V2 premium features
  | 'ai_insights'
  | 'ai_suggestions'
  | 'ai_chat'
  | 'ai_summaries'
  | 'advanced_analytics'
  | 'unlimited_voice_notes'
  | 'unlimited_linkedin_imports'

export type Role = 'free' | 'premium'

const featureAccess: Record<Feature, Role[]> = {
  // V1 -- all free
  contacts: ['free', 'premium'],
  circles: ['free', 'premium'],
  labels: ['free', 'premium'],
  interactions: ['free', 'premium'],
  todos: ['free', 'premium'],
  gifts: ['free', 'premium'],
  voice_notes: ['free', 'premium'],
  reminders: ['free', 'premium'],
  search: ['free', 'premium'],
  import: ['free', 'premium'],
  export: ['free', 'premium'],

  // V2 -- premium only
  ai_chat: ['premium'],
  ai_insights: ['premium'],
  ai_suggestions: ['premium'],
  ai_summaries: ['premium'],
  advanced_analytics: ['premium'],
  unlimited_voice_notes: ['premium'],
  unlimited_linkedin_imports: ['premium'],
}

export function canAccess(feature: Feature, role: Role): boolean {
  return featureAccess[feature]?.includes(role) ?? false
}
